import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { yupResolver } from '@hookform/resolvers/yup'

import styles from './EditUser.module.css'

import SlideOverModal from 'Layout/SlideOverModal'

import Button from 'Design/components/Button'
import FormControl from 'Design/components/FormControl'
import Label from 'Design/components/Label'
import Input from 'Design/components/Input'
import FormErrorText from 'Design/components/FormErrorText'

import Permissions from '../components/Permissions'

import editUserFormValidationSchema from './edituser-form-validation-schema'
import { useUpdateUserMutation } from '../users.service'

const EditUser = (props) => {
  const { hide, user } = props

  const {
    register,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    defaultValues: {
      name: user.name,
      email: user.email,
      permissions: user.permissions
    },
    resolver: yupResolver(editUserFormValidationSchema)
  })

  const [updateUser, updateUserResult] = useUpdateUserMutation()

  const handleFormSubmit = (data) => {
    const payload = {
      id: user.id,
      name: data.name,
      email: data.email,
      permissions: data.permissions
    }

    const promise = updateUser(payload).unwrap()

    toast.promise(promise, {
      loading: 'Updating user...',
      success: 'User details updated successfully',
      error: 'Error while updating user details. Try again.'
    })
  }

  return (
    <SlideOverModal title='Edit User' onHide={hide}>
      <form onSubmit={handleSubmit(handleFormSubmit)} className={styles.Form}>
        <FormControl isInvalid={errors.name}>
          <Label>Name</Label>
          <Input {...register('name')} />
          {errors.name && <FormErrorText>{errors.name.message}</FormErrorText>}
        </FormControl>
        <FormControl isInvalid={errors.email}>
          <Label>Email</Label>
          <Input {...register('email')} disabled readOnly />
          {errors.email && <FormErrorText>{errors.email.message}</FormErrorText>}
        </FormControl>
        <Controller
          control={control}
          name='permissions'
          render={({ field: { value, onChange } }) => {
            return <Permissions permissions={value} onChange={onChange} />
          }}
        />
        <div className={styles.ButtonsContainer}>
          <Button type='submit' variant='primary' disabled={updateUserResult.isLoading}>
            Save
          </Button>
          <Button variant='link-muted' onClick={hide} disabled={updateUserResult.isLoading}>
            Cancel
          </Button>
        </div>
      </form>
    </SlideOverModal>
  )
}

export default EditUser
